module.exports = __webpack_public_path__ + "img/avatar-1.d2cf072e.jpg";